<script lang="ts">
  import Players from '../../Players/Listed.svelte'
  import { players } from '../../Players/observables'
  import type { RetroAuthedUser } from '../../Users/types'
  import TopBarPage from '../../Navigation/TopLevelPages/TopBarPage.svelte'
  import LeaderButton from './LeaderButton.svelte'
  import { state } from '../State'
  import { generateCurrentAppLocation } from '../../utilities/helpers'
  export let user: RetroAuthedUser
</script>

<TopBarPage>
  <div class="game">
    <Players players={$players} />
    <h2>Attendees should follow the link below to join:</h2>
    <h2>{`${generateCurrentAppLocation(document)}/${user.organization}`}</h2>
    {#if user.uid === $state?.leader}
      <LeaderButton />
    {/if}
  </div>
</TopBarPage>

<style>
</style>
